import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/layout/AppShell';
import { RequireAuth } from './auth/RequireAuth';
import { BoardPage } from './pages/BoardPage';
import { CustomersPage } from './pages/CustomersPage';
import { PartnersPage } from './pages/PartnersPage';
import { CustomerDetailPage } from './pages/CustomerDetailPage';
import { OpportunityDetailPage } from './pages/OpportunityDetailPage';
import { MyActionsPage } from './pages/MyActionsPage';
import { AuthRedirectPage } from './pages/AuthRedirectPage';
import { NotFoundPage } from './pages/NotFoundPage';

/** Ctrl/⌘+K is handled at the app level so it works from any screen. The AppShell owns the
 *  dialog, so we dispatch a custom event it listens for. */
function useGlobalSearchShortcut() {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        window.dispatchEvent(new CustomEvent('crm:open-search'));
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);
}

export function App() {
  useGlobalSearchShortcut();

  return (
    <Routes>
      <Route path="/auth" element={<AuthRedirectPage />} />
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route path="/" element={<BoardPage />} />
        <Route path="/customers" element={<CustomersPage />} />
        <Route path="/customers/:id" element={<CustomerDetailPage />} />
        <Route path="/partners" element={<PartnersPage />} />
        <Route path="/opportunities/:id" element={<OpportunityDetailPage />} />
        <Route path="/my-actions" element={<MyActionsPage />} />
        <Route path="/index.html" element={<Navigate to="/" replace />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
